import { useState } from "react";

import { format } from "date-fns";

import useData from "../../hooks/useData";

import {
  FormControl,
  OutlinedInput,
  InputLabel,
  FormHelperText,
  IconButton,
  InputAdornment,
  Box,
  Typography,
} from "@mui/material";
import TimerIcon from "@mui/icons-material/Timer";

import useLocalization from "../../hooks/useLocalization";

const Time = ({
  id,
  label,
  value,
  onChange,
  fullwidth,
  message,
  error,
  required,
  disabled,
  allowSetNow,
  dateValue,
}) => {
  const { getMessage, getLabel } = useLocalization();
  const [focus, setFocus] = useState(false);
  const { toDate } = useData();

  const getValue = () => {
    if (!value) return "";

    // Convert to Date object using toDate helper
    const date = toDate(value);
    if (!date) return "";

    return format(date, "HH:mm");
  };

  const updateValue = (e) => {
    const timeValue = e.target.value;

    if (!timeValue) {
      onChange("");
      return;
    }

    const [hourText, minuteText] = timeValue.split(":");
    const hour = Number(hourText);
    const minute = Number(minuteText);

    if (!Number.isInteger(hour) || !Number.isInteger(minute)) {
      return;
    }

    const baseDate = toDate(dateValue) || toDate(value) || new Date();
    const nextDate = new Date(baseDate);
    nextDate.setHours(hour, minute, 0, 0);

    onChange(nextDate);
  };

  const handleSetNow = () => {
    const baseDate = toDate(dateValue) || toDate(value) || new Date();
    let now = new Date();
    now.setFullYear(baseDate.getFullYear());
    now.setMonth(baseDate.getMonth());
    now.setDate(baseDate.getDate());

    onChange(now);
  };

  return (
    <Box>
      <Box sx={{ paddingLeft: "6px", paddingRight: "6px" }}>
        <Typography sx={{ fontSize: "10px", fontWeight: "bold" }}>
          {getLabel(label)}
        </Typography>
      </Box>

      <FormControl
        id={id}
        fullWidth={fullwidth}
        size="small"
      >
        <OutlinedInput
          onFocus={() => setFocus(true)}
          onBlur={() => setFocus(false)}
          id={id}
          value={getValue()}
          error={error || false}
          onChange={updateValue}
          type={value || focus ? "time" : "text"}
          required={required}
          fullWidth={fullwidth}
          disabled={disabled}
          size="small"
          endAdornment={
            allowSetNow ? (
              <InputAdornment position="end">
                <IconButton
                  onClick={handleSetNow}
                  edge="end"
                  sx={{ padding: "0px" }}
                >
                  <TimerIcon />
                </IconButton>
              </InputAdornment>
            ) : null
          }
          sx={{ fontSize: "12px" }}
        />

        <FormHelperText error={error || false}>
          {getMessage(message) || ""}
        </FormHelperText>
      </FormControl>
    </Box>
  );
};

export default Time;
